module.exports = __webpack_public_path__ + "static/media/block-2_15.c7a8acf7.svg";